# Keep only the sentences in the authorized char limit + tolerance for last sentence to not cut it
export default class TruncateSources

  constructor: (sources, maxSize, tolerance) ->
    @sources   = sources
    @maxSize   = maxSize
    @tolerance = tolerance

  run: ->
    charsCount = 0

    # Keep only the complete sentences in the authorized char limit
    truncatedSources = _.takeWhile(@sources, (source) =>
      charsCount += source.length
      charsCount < @maxSize
    )

    # Add the last sentence but only the part that fits in "maxSize + tolerance"
    if @sources.length > truncatedSources.length
      nextSource          = @sources[truncatedSources.length]
      charsCount          = charsCount - nextSource.length # Restore count of chars of truncatedSources
      remainingMaxChars   = @maxSize - charsCount + @tolerance
      truncatedNextSource = nextSource[0...remainingMaxChars].trim()

      truncatedSources.push(truncatedNextSource) if truncatedNextSource != ''

    truncatedSources
